module.exports = __webpack_public_path__ + "img/add_expense_dollar_sign.b6502dac.svg";